import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import routes from 'router/routes';
import Routes from 'router/components/Routes/Routes';
import AuthProvider from './providers/Auth';
import PopNotificationsProvider from 'providers/PopNotifications';
import GeneralProvider from 'providers/General';
import ScrollToProvider from 'providers/ScrollTo';
import * as Sentry from '@sentry/react';
import SentryErrorBoundaryFallback from 'components/SentryErrorBoundaryFallback';
import HelmetWrapper from 'components/HelmetWrapper';
import TrendingListings from 'providers/TrendingListings';
import Enquiry from 'providers/Enquiry';
import sentryService from 'services/sentryService';
import mixpanelService from 'services/mixpanelService';
import DraftListingProvider from 'providers/DraftListing';
import CreateDataRoomProvider from 'providers/CreateDataRoom';
import { Toaster } from 'react-hot-toast';
import QueryClientProvider from 'providers/QueryClient';
import useScrollingClass from 'hooks/useScrollingClass';

sentryService.init();
mixpanelService.init();

function App() {
  useScrollingClass();

  return (
    <Sentry.ErrorBoundary fallback={<SentryErrorBoundaryFallback />}>
      <HelmetWrapper />
      <QueryClientProvider>
        <BrowserRouter>
          <Toaster />
          <PopNotificationsProvider>
            <AuthProvider>
              <GeneralProvider>
                <CreateDataRoomProvider>
                  <Enquiry>
                    <TrendingListings>
                      <DraftListingProvider>
                        <ScrollToProvider>
                          <Routes routes={routes} />
                        </ScrollToProvider>
                      </DraftListingProvider>
                    </TrendingListings>
                  </Enquiry>
                </CreateDataRoomProvider>
              </GeneralProvider>
            </AuthProvider>
          </PopNotificationsProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
